import gt from './gt';
import ni from './ni';
import hn from './hn';
import cr from './cr';
import sv from './sv';
import pa from './pa';

export default {
  gt,
  ni,
  hn,
  cr,
  sv,
  pa
};
// export default {
//   gt: {gt},
//   ni: {ni},
//   hn: {hn},
//   cr: {cr},
//   sv: {sv},
//   pa: {pa}
// };
